import React from 'react'
import { ApolloProvider } from '@apollo/react-hooks'
import { ThemeProvider } from 'styled-components'

import { client } from './../apollo'
import { defaultTheme, GlobalStyles } from 'src/ui/theme'
import { DimensionsProvider } from 'src/ui/dimensions'

import { SnackContainer } from 'src/shared/features/snack'
import { Banner } from 'src/shared/features/banner'
import { VoteBanner } from 'src/shared/features/vote-banner'

type Props = {
  element: JSX.Element
}

export const wrapRootElement = (props: Props) => (
  <ApolloProvider client={client}>
    <ThemeProvider theme={defaultTheme}>
      <GlobalStyles>
        <DimensionsProvider>
          {props.element}
          <div id="modal"></div>
          <SnackContainer />
          {/* <Banner type="analytics" /> */}
          {/* <VoteBanner /> */}
        </DimensionsProvider>
      </GlobalStyles>
    </ThemeProvider>
  </ApolloProvider>
)
